export default (() => {
    // Close contact flyout when tab navigation has passed it
    const targetEl = document.querySelector('#nav-drawer-contact .js-close-on-unfocus');
    if (targetEl) {
        targetEl.addEventListener('blur', () => {
            const activeContactDrawer = document.querySelector('.MobileMenu__contact-icon.toggled');
            if (activeContactDrawer) {
                activeContactDrawer.dispatchEvent(
                    new CustomEvent('dynamic-click', { bubbles: true })
                );
            }
        });
    }
})();
